<app-test>
    <ng-container slot="progress">
        <div class="bg-background-dark w-full rounded-xl shadow-sm overflow-hidden mr-8">
            <div class="relative h-4 flex items-center justify-center">
                <div #progressbar class="absolute top-0 bottom-0 left-0 rounded-lg bg-blue transition-all"></div>
            </div>
        </div>
        <div class="flex flex-col items-center align-center w-[40px]">
            <ng-icon name="faSolidGem" [size]="progressGemSize" class="text-orange"></ng-icon>
            <span class="text-xs font-bold whitespace-nowrap notranslate">{{ streakProgress.current }} von {{
                streakProgress.next
                }}</span>
        </div>
    </ng-container>

    @if(!evaluation || evaluation.length == 0){
    <app-question slot="question" [orderSeed]="orderSeed" [question]="activeQuestion" [index]="index" [showFlag]="false"
        [flagged]="flagged" (questionFlagged)="handleQuestionFlagged()"
        (answersSelected)="handleAnswersSelected($event)" />
    } @else {
    <app-answer slot="question" [question]="activeQuestion" [evaluation]="evaluation" [index]="index" [showFlag]="false"
        [flagged]="flagged" [bookmarkInfo]="{responseId: currentResponseId, courseId: courseId}"></app-answer>
    }
    <ng-container slot="buttons">
        <button class="z-10 white-button" (click)="toggleSubmitWarningModal()">Beenden</button>
        @if(evaluation && evaluation.length > 0){
        <button class="z-10 blue-button" (click)="nextQuestion()">
            Nächste Frage
        </button>
        } @else if(currentAnswers && currentAnswers.length > 0) {
        <button class="z-10 blue-button" (click)="submitAnswer()">
            Weiter
        </button>
        } @else {
        <button class="z-10 disabled-button">
            Weiter
        </button>
        }
    </ng-container>
</app-test>

<app-modal #submitWarningModal>
    <div class="flex flex-row items-center w-full h-full">
        <div class="flex flex-col items-center w-full text-center">
            <img src="./assets/img/penguin-warning.png" alt="Warnung" class="w-40 h-40 rounded-full" />
            <h3 class="pt-6 pb-4">Bist du sicher, dass du den Endlosmodus beenden möchtest?</h3>
            <p class="px-20 text-center">Du wirst danach auf deinen Trainingsbereich weitergeleitet.</p>
            <div class="flex flex-row justify-between gap-4 mt-6">
                <button class="orange-button" (click)="toggleSubmitWarningModal(); toggleResultModal()">
                    Beenden
                </button>
                <button class="blue-button" (click)="toggleSubmitWarningModal()">
                    Ich schaffe mehr!
                </button>
            </div>
        </div>
    </div>
</app-modal>

<app-modal #resultModal>
    <div class="flex flex-row items-center w-full h-full">
        <div class="flex flex-col items-center w-full text-center">
            <img src="./assets/img/penguin-lightbulb.webp" alt="Pinguin mit Glühbirne"
                class="w-40 h-40 rounded-full object-cover" />
            <h3 class="pt-6 pb-4">Super!</h3>
            <p class="px-20 text-center">Du hast in {{ totalElapsedSeconds * 1000 | date:'mm:ss' }} Minuten {{
                totalCount }} Fragen beantwortet. Davon waren {{ correctCount }} richtig!</p>
            <a routerLink="/training">
                <button class="blue-button mt-6">
                    Wow!
                </button>
            </a>
        </div>
    </div>
</app-modal>

<app-modal #achievementModal>
    <div class="flex flex-col items-center text-center h-full">
        <img src="./assets/img/penguin-with-squid.png" alt="Pinguin mit Fisch"
            class="mt-12 mb-6 w-40 h-40 rounded-full" />
        <h3 class="pb-4">Neuer Erfolg freigeschaltet!</h3>
        <p class=" text-lg font-bold text-orange">{{ achievement?.achievement?.count }} Richtige am Stück!</p>
        <p>Super gemacht!</p>
        @if (achievement?.nextCount) {
        <p>Nächstes Ziel: {{ achievement?.nextCount }} Richtige am Stück</p>
        }
        <button class="blue-button mt-10 w-3/4" (click)="toggleAchievementModal()">Yaay!</button>
    </div>
</app-modal>